import { createContext, useContext, useState, ReactNode, Dispatch, SetStateAction } from "react";

interface UnityActionsContextType {
  modelDensity: number | null;
  setModelDensity: Dispatch<SetStateAction<number | null>>;
  show3DModel: boolean;
  setShow3DModel: Dispatch<SetStateAction<boolean>>;
  editingMode: boolean;
  setEditingMode: Dispatch<SetStateAction<boolean>>;
  cameraMode: boolean;
  setCameraMode: Dispatch<SetStateAction<boolean>>;
  idleCameraMode: boolean;
  setIdleCameraMode: Dispatch<SetStateAction<boolean>>;
  widgetSwitch: boolean;
  setWidgetSwitch: Dispatch<SetStateAction<boolean>>;
  renderQuality: number;
  setRenderQuality: Dispatch<SetStateAction<number>>;
  cameraSpeed: number;
  setCameraSpeed: Dispatch<SetStateAction<number>>;
  viewMode: number;
  setViewMode: Dispatch<SetStateAction<number>>;
  measurementMode: boolean;
  setMeasurementMode: Dispatch<SetStateAction<boolean>>;
  screenMode: number;
  setScreenMode: Dispatch<SetStateAction<number>>;
  selectedCharacter: number;
  setSelectedCharacter: Dispatch<SetStateAction<number>>;
  isMovementDisabled: number;
  setIsMovementDisabled: Dispatch<SetStateAction<number>>;
  cameraReset: boolean;
  setCameraReset: Dispatch<SetStateAction<boolean>>;
}

const UnityActionsContext = createContext<UnityActionsContextType | undefined>(undefined);

export const UnityActionsProvider = ({ children }: { children: ReactNode }) => {
  const [modelDensity, setModelDensity] = useState<number | null>(1);
  const [show3DModel, setShow3DModel] = useState(false);
  const [editingMode, setEditingMode] = useState(false);
  const [cameraMode, setCameraMode] = useState(true);
  const [idleCameraMode, setIdleCameraMode] = useState(false);
  const [widgetSwitch, setWidgetSwitch] = useState(true);
  const [renderQuality, setRenderQuality] = useState(0);
  const [cameraSpeed, setCameraSpeed] = useState(0);
  const [viewMode, setViewMode] = useState<number>(0);
  const [screenMode, setScreenMode] = useState<number>(Number(localStorage.getItem('windowMode')));
  const [measurementMode, setMeasurementMode] = useState(false);
  const [selectedCharacter, setSelectedCharacter] = useState<number>(0);
  const [isMovementDisabled, setIsMovementDisabled] = useState<number>(0);
  const [cameraReset, setCameraReset] = useState(false);

  return (
    <UnityActionsContext.Provider value={{
      modelDensity, setModelDensity,
      show3DModel, setShow3DModel,
      editingMode, setEditingMode,
      cameraMode, setCameraMode,
      idleCameraMode, setIdleCameraMode,
      widgetSwitch, setWidgetSwitch,
      renderQuality, setRenderQuality,
      cameraSpeed, setCameraSpeed,
      viewMode, setViewMode,
      screenMode, setScreenMode,
      measurementMode, setMeasurementMode,
      selectedCharacter, setSelectedCharacter,
      isMovementDisabled, setIsMovementDisabled,
      cameraReset, setCameraReset
    }}>
      {children}
    </UnityActionsContext.Provider>
  );
};

export const useUnityActions = () => {
  const context = useContext(UnityActionsContext);
  if (!context) {
    throw new Error("useUnityActions must be used within a UnityActionsProvider");
  }
  return context;
};